var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"profile-button",class:{ 'large-icon': _vm.large },attrs:{"to":"/profile/account/"}},[_c('logo-icon',{attrs:{"large":_vm.large,"custom-sizes":_vm.customSizes,"src":_vm.userTeam.logo,"full":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }